<template>
	<!-- <span> -->
	<v-container fluid fill-height class="hero" style="max-height: 40vh;">
		<v-row justify-center fill-height class="hero-title">
			<v-col class="text-right headline">
				<h1 class="font-weight-black">با پاسخ‌های شما، آینده‌ای بهتر می‌سازیم!</h1>
			</v-col>
			<v-spacer class="hidden-md-and-down"></v-spacer>
		</v-row>
	</v-container>
	<!-- </span> -->
</template>

<script>
export default {
	name: "QstHero"
};
</script>

<style scoped>
.hero {
	background: url("~@/assets/img/docs-hero.png");
	background-size: cover;
	width: 100%;
	height: 100%;
}

.hero .headline {
	max-width: 65%;
}

@media (max-width: 768px) {
	.hero {
		max-height: 20% !important;
	}

	.hero .hero-title {
		margin-top: auto;
	}

	.hero .headline * {
		font-size: small !important;
	}
}
</style>
